const getPagesCount = (link: string) => {
  const matches = link.match(/page=\d+/);
  if (!matches) {
    return 1;
  }
  return +matches[0].replace(/page=/, '');
};

export default getPagesCount;
